// extracted by mini-css-extract-plugin
module.exports = {"root":"ToggleButtons_root__W3Raj","fullWidth":"ToggleButtons_fullWidth__hYzOU","disabled":"ToggleButtons_disabled___9D0W","isSelected":"ToggleButtons_isSelected__hmqr9"};